module.exports = __webpack_public_path__ + "img/symbol_4.205ee676.png";